function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Social_Twitter_ic"
}, /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 152,
  height: 152,
  rx: 20,
  ry: 20,
  "data-name": "Apps_ic"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.65 71.14v-.12a15.31 15.31 0 00-7.75-13.32c-2.82 14.78-15.4 25.14-27.16 25.6h-1.63c-4.32-.07-8.06.07-12.38 0a3.92 3.92 0 00-2.28.8 4.63 4.63 0 00-1.52 2.36l-1.5 8.93-4.31 25.88a2.33 2.33 0 002.3 2.7h14a3.65 3.65 0 003.6-3.1l3-19a4 4 0 011.31-2 3.44 3.44 0 012-.71c3.73.06 3.21-.06 6.94 0H96c.18 0 .35.06.53.05h.17v-.05c11.51-.45 24-11.89 24-27.42-.03-.24-.05-.41-.05-.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.49 51.54a32.92 32.92 0 01-.59 6.17c-2.82 14.78-15.4 25.14-27.16 25.6h-1.63c-4.32-.07-8.06.07-12.38 0a3.92 3.92 0 00-2.28.8 4.63 4.63 0 00-1.52 2.36l-1.5 8.93-2.94 16.66H45.33a1.92 1.92 0 01-1.9-2.23l12.1-73.76A3.67 3.67 0 0159.15 33h37.4a17.77 17.77 0 0116.94 17.73z"
}));

var SvgPaypal = function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 160",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgPaypal;